var template = require('./template.hbs');

module.exports = Backbone.View.extend({
  events: {
    'click .overlay': 'closeEvent',
    'click .menu-lock': 'showEvent'
  },

  closeEvent: function () {
    this.$el.removeClass('display-widget');
  },

  showEvent: function () {
    this.show();
  },

  initialize: function () {
    var EditorFacade = require('../../../../facade/editor/editor');
    _.bindAll(this, 'show', 'enableMenu', 'setTotal', 'finishLoading', 'paidItemEvent');
    this.$button = $('header > .options [data-action="shopping-cart"]');

    this.$button.on('click', this.show);

    if (!INKIVE.C.IS_MOBILE) {
      this.$button.addClass('disabled');
      INKIVE.Helpers.getScript('https://js.stripe.com/v3');

      this.render();
      var $widgetContainer = this.$el.children('.widget-container');

      INKIVE.Modal.loader(this.$button.addClass('loading'));
      INKIVE.Helpers.getAureliaLibraries($widgetContainer.find('[aurelia-app="shopping-cart/main"]'))
        .then(this.finishLoading);
      EditorFacade.on('shopping_cart.add', _.partial(this.toggleItemInCartEvent, true));
      EditorFacade.on('shopping_cart.removed', _.partial(this.toggleItemInCartEvent, false));
      EditorFacade.on('shopping_cart.paid', this.paidItemEvent);
    }
  },

  setTotal: function (total) {
    this.$button.find('.total').text(total || '-');

    total === 0 && this.hideCartOption();
    total === 1 && this.displayCartOption();
  },

  displayCartOption: function () {
    this.$button.removeClass('disabled').removeClass('hidden');

    var width = 0;

    $('header > .options [data-action]').each(function () {
      var $button = $(this);

      if (!$button.is('[data-action="shopping-cart"]')) {
        width += $button.outerWidth(true);
      }
    });

    this.$el.find('.menu-lock').width(width).show();
  },

  hideCartOption: function () {
    this.$button.addClass('hidden');

    this.$el.removeClass('display-widget');
    this.$el.find('.menu-lock').hide();
    INKIVE.Tool.enableUI();
  },

  enableMenu: function () {
    this.$button.addClass('hidden');

    this.$el.find('.menu-lock').hide();
  },

  render: function () {
    this.$el.html(template());
  },

  show: function () {
    this.$el && this.$el.addClass('display-widget');
    INKIVE.Tool.disableUI();
    this.$el.find('.overlay').one('click', INKIVE.Tool.enableUI);
  },

  finishLoading: function () {
    $('header > .options').removeClass('disabled');
    INKIVE.Modal.loaderClose(this.$button);
    this.$button.removeClass('loading');
    $('#shopping-cart-panel').css('display', 'block');
  },

  toggleItemInCartEvent: function (added, data) {
    data = data || {};
    var $thumb = $('#photo-' + data.id).parents('.thumbnail');
    var $link = $thumb.find('.subscription-label').toggleClass('in-shopping-cart', added);
    var label = added ? '<i class="wb-icon-success"></i>' : $thumb.data('label');
    var hoverText = added ? label + INKIVE.TranslateHelper.translate('tool.search.in_shopping_cart')
      : $thumb.data('hover-text');

    if (data.licence && INKIVE.Helpers.isUrlValid(data.licence)) {
      label = '<i class="wb-icon-success"></i>';
      hoverText = label + INKIVE.TranslateHelper.translate('tool.search.licenced_item');
      $link.addClass('licenced');
      $thumb.find('.item').data('licenced_url', data.licence);
    }

    $link.html(label);
    $thumb.hover(
      function () {
        $link.addClass('hover').html(hoverText);
      }, function () {
      $link.removeClass('hover').html(label);
    }
    );
  },

  paidItemEvent: function (data) {
    data && _.each(data.info, _.bind(function (item) {
      this.toggleItemInCartEvent(false, {
        id: item.licence['licence_id'],
        licence: data.info[0].data.source
      });
    }, this));
  }

});
